import { useEffect, useReducer } from "react";
import { getUtcDateString } from "utils/dateUtils";

const useCurrentUtcDate = (enabled: boolean): string | undefined => {
  const [, refreshCurrentUtcDate] = useReducer((value) => value + 1, 0);
  const currentUtcDate = getUtcDateString();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const now = new Date();
    const nextUtcDate = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1
    );
    const timeoutId = window.setTimeout(
      refreshCurrentUtcDate,
      nextUtcDate - now.getTime()
    );

    return () => window.clearTimeout(timeoutId);
  }, [currentUtcDate, enabled]);

  return enabled ? currentUtcDate : undefined;
};

export default useCurrentUtcDate;
